import brands from '@/brands/brands.js';


export function brandDetector() {


	var domain = location.host;


	var brandsIndex = {
		//PRO
		'tutor.uvaempleo.com': 'uva',
		//PRE
		'tutores-uva.dev.doubledot.es': 'uva',
		//LOCAL
		'localhost:8080': 'uva'
	};

	var selected = brandsIndex[domain];

	//SETEO DE LOS FAVICONS

	if (!!selected) {

		if (!!brands[selected].hasFavicon) {

			var url = '/static/img/brands/' + selected + '/favicon/';


		}

		return brands[selected];


	} else {
		return brands['dotia'];
	}

}


// WEBPACK FOOTER //
// ./src/brands/index.js